import React from 'react';
import ReloadButton from '../../../../../features/ReloadButton/ReloadButton';
import { InputFieldSearch } from '../../../../../utils/InputField';
import { useBillingQuotation } from '../QuotationListProvider';

function PageHeaderLeftCol({ p, onChangeHandler }) {
    return (
        <div
            // onSubmit={handleOnEnter}
            className="customers_page_header_left_col flex-1 flex flex-row items-center gap-x-2 md:gap-x-4"
        >
            <InputFieldSearch
                label="Search by quotation number or customer...."
                name="q"
                onChange={onChangeHandler}
                formData={p}
                className="w-72"
            />
        </div>
    );
}

function PageHeaderRightCol() {
    const { handleReload } = useBillingQuotation();
    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center ">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

function QuotationListPageHeader({ p, onChangeHandler }) {
    return (
        <div className="customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol p={p} onChangeHandler={onChangeHandler} />
            <PageHeaderRightCol />
        </div>
    );
}

export default QuotationListPageHeader;
